import {
  REPORT_CHANGE_PEROID,
  REPORT_CHANGE_DAY,
  REPORT_CHANGE_START_DAY,
  REPORT_CHANGE_END_DAY,
  REPORT_SET_ERRORS,
  REPORT_CHANGE_RESET_DAY,
  REPORT_CHANGE_RESET_RANGE,
  REPORT_SET_LOADING,
} from '../../constants/ActionTypes';

const getMomentDay = () => new Date();
const getMomentStartDay = () =>
  new Date(new Date().setDate(new Date().getDate() - 1));

const getMomentEndDay = () => new Date();

const reports = (
  state = {
    errors: {},
    loading: false,
    peroid: 'day',
    day: getMomentDay(),
    startDay: getMomentStartDay(),
    endDay: getMomentEndDay(),
  },
  action
) => {
  switch (action.type) {
    case REPORT_CHANGE_PEROID:
      return { ...state, peroid: action.data };
    case REPORT_CHANGE_DAY:
      return { ...state, day: action.data };
    case REPORT_CHANGE_START_DAY:
      return { ...state, startDay: action.data };
    case REPORT_CHANGE_END_DAY:
      return { ...state, endDay: action.data };
    case REPORT_SET_ERRORS:
      return { ...state, errors: action.data };
    case REPORT_CHANGE_RESET_DAY:
      return { ...state, day: getMomentDay() };
    case REPORT_CHANGE_RESET_RANGE:
      return {
        ...state,
        startDay: getMomentStartDay(),
        endDay: getMomentEndDay(),
      };
    case REPORT_SET_LOADING:
      return { ...state, loading: action.data };
    default:
      return state;
  }
};

export default reports;
